export default {
  id: '8e2ea37f92',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\n  <div class="page kyc" data-name="kyc">\n\n    <!-- Navbar -->\n    <div class="navbar kyc__navbar no-shadow">\n      <div class="navbar-bg"></div>\n      <div class="navbar-inner">\n        <div class="left">\n          <a href="#" class="link back kyc__back" aria-label="Back">\n            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="15 18 9 12 15 6"/></svg>\n          </a>\n        </div>\n        <div class="title kyc__navbar-title">Identity Verification</div>\n        <div class="right"></div>\n      </div>\n    </div>\n\n    <div class="page-content kyc__content">\n      <!-- Status hero (rendered by routes.js) -->\n      <div class="kyc__status"><div class="kyc__loading"><span class="kyc__spinner"></span>Loading your KYC status\u2026</div></div>\n      <!-- Form or submitted view (rendered by routes.js) -->\n      <div class="kyc__body"></div>\n      <div class="kyc__end-gap"></div>\n    </div>\n  </div>\n';
      return r;
    }(this);
  },
  style: `
/* ════════ KYC PAGE (kyc__*) ════════ */
.kyc { background: #08070A !important; }
.kyc__content {
  background:
    radial-gradient(120% 38% at 50% 0%, rgba(201,169,105,0.13) 0%, transparent 58%),
    radial-gradient(90% 30% at 100% 8%, rgba(120,90,200,0.06) 0%, transparent 60%),
    #08070A !important;
  padding: 16px 15px calc(44px + env(safe-area-inset-bottom)) !important;
  margin-top: 60px !important;
}
.kyc__navbar { background: linear-gradient(180deg, #100E09 0%, #0A0907 100%) !important; }
.kyc__navbar:after { display: none !important; }
.kyc__navbar .navbar-bg { background: transparent !important; }
.kyc__navbar-title { color: var(--gold) !important; font-weight: 700; letter-spacing: 0.01em; }
.kyc__back { color: rgba(201,169,105,0.85) !important; }
.kyc__loading { display: flex; align-items: center; justify-content: center; gap: 10px; padding: 50px 20px; color: rgba(255,255,255,0.45); font-size: 13px; }
.kyc__spinner { width: 16px; height: 16px; border-radius: 50%; border: 2px solid rgba(201,169,105,0.25); border-top-color: var(--gold); animation: kycSpin .7s linear infinite; }
@keyframes kycSpin { to { transform: rotate(360deg); } }

/* ── Status hero ── */
.kyc__hero {
  position: relative; overflow: hidden; text-align: center;
  border-radius: 24px; padding: 30px 22px 24px; margin-bottom: 6px;
  border: 1px solid rgba(255,255,255,0.07);
  background:
    linear-gradient(165deg, rgba(255,255,255,0.05) 0%, rgba(255,255,255,0) 40%),
    linear-gradient(160deg, #18140E 0%, #100F12 100%);
  box-shadow: 0 24px 50px -22px rgba(0,0,0,0.7), inset 0 1px 0 rgba(255,255,255,0.05);
}
.kyc__hero-glow {
  position: absolute; top: -70px; left: 50%; transform: translateX(-50%);
  width: 240px; height: 240px; border-radius: 50%; pointer-events: none;
  background: radial-gradient(circle, rgba(201,169,105,0.28), transparent 68%);
  opacity: 0.6;
}
.kyc__hero-ico {
  position: relative; z-index: 1;
  width: 76px; height: 76px; border-radius: 22px; margin: 0 auto 16px;
  display: flex; align-items: center; justify-content: center;
}
.kyc__hero-ico:before {
  content: ''; position: absolute; inset: -7px; border-radius: 28px;
  background: inherit; filter: blur(11px); opacity: 0.5; z-index: -1;
}
.kyc__hero-badge {
  position: absolute; right: -4px; bottom: -4px; width: 26px; height: 26px; border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  border: 2.5px solid #131114;
}
.kyc__hero-title { position: relative; z-index: 1; font-size: 20px; font-weight: 800; color: #fff; margin: 0; letter-spacing: -0.01em; }
.kyc__hero-sub { position: relative; z-index: 1; font-size: 12.5px; color: rgba(255,255,255,0.55); margin: 9px auto 0; line-height: 1.6; max-width: 320px; }

/* state accents */
.kyc__hero--approved .kyc__hero-ico { background: rgba(74,222,128,0.14); border: 1px solid rgba(74,222,128,0.34); color: #4ade80; }
.kyc__hero--approved .kyc__hero-title { color: #5ee68f; }
.kyc__hero--approved .kyc__hero-badge { background: #4ade80; color: #06320f; }
.kyc__hero--approved { border-color: rgba(74,222,128,0.22); }
.kyc__hero--pending .kyc__hero-ico { background: rgba(251,191,36,0.13); border: 1px solid rgba(251,191,36,0.32); color: #fbbf24; }
.kyc__hero--pending .kyc__hero-title { color: #fcd34d; }
.kyc__hero--pending .kyc__hero-badge { background: #fbbf24; color: #3a2c05; }
.kyc__hero--rejected .kyc__hero-ico { background: rgba(255,107,92,0.13); border: 1px solid rgba(255,107,92,0.32); color: #ff6b5c; }
.kyc__hero--rejected .kyc__hero-title { color: #ff8b7c; }
.kyc__hero--rejected .kyc__hero-badge { background: #ff6b5c; color: #3a0d07; }
.kyc__hero--rejected { border-color: rgba(255,107,92,0.22); }
.kyc__hero--none .kyc__hero-ico { background: rgba(201,169,105,0.13); border: 1px solid rgba(201,169,105,0.32); color: #e6cf95; }
.kyc__hero--none .kyc__hero-title { color: #f3e2b6; }
.kyc__hero--none .kyc__hero-badge { background: var(--gold); color: #2a2008; }

/* ── Progress steps ── */
.kyc__steps { position: relative; z-index: 1; display: flex; align-items: flex-start; justify-content: center; gap: 0; margin: 22px auto 2px; max-width: 320px; }
.kyc__step { flex: 1; position: relative; display: flex; flex-direction: column; align-items: center; gap: 7px; }
.kyc__step-dot {
  width: 30px; height: 30px; border-radius: 50%; display: flex; align-items: center; justify-content: center;
  background: rgba(255,255,255,0.05); border: 1.5px solid rgba(255,255,255,0.14); color: rgba(255,255,255,0.4);
  font-size: 12px; font-weight: 800; position: relative; z-index: 2; transition: all .2s;
}
.kyc__step-lbl { font-size: 10px; font-weight: 600; color: rgba(255,255,255,0.4); letter-spacing: 0.01em; line-height: 1.3; }
.kyc__step:not(:last-child):after {
  content: ''; position: absolute; top: 15px; left: 50%; width: 100%; height: 2px;
  background: rgba(255,255,255,0.1); z-index: 1;
}
.kyc__step--done .kyc__step-dot { background: rgba(74,222,128,0.16); border-color: rgba(74,222,128,0.5); color: #4ade80; }
.kyc__step--done .kyc__step-lbl { color: rgba(255,255,255,0.62); }
.kyc__step--done:not(:last-child):after { background: rgba(74,222,128,0.45); }
.kyc__step--active .kyc__step-dot { background: rgba(201,169,105,0.18); border-color: var(--gold); color: #f3e2b6; box-shadow: 0 0 0 4px rgba(201,169,105,0.12); }
.kyc__step--active .kyc__step-lbl { color: #f3e2b6; }
.kyc__step--error .kyc__step-dot { background: rgba(255,107,92,0.16); border-color: rgba(255,107,92,0.5); color: #ff6b5c; }
.kyc__step--error .kyc__step-lbl { color: #ff8b7c; }

.kyc__remark {
  position: relative; z-index: 1; margin: 18px 0 0; padding: 12px 14px; border-radius: 14px; text-align: left;
  background: rgba(255,107,92,0.1); border: 1px solid rgba(255,107,92,0.24);
  font-size: 12px; color: rgba(255,255,255,0.72); line-height: 1.55;
  display: flex; gap: 9px; align-items: flex-start;
}
.kyc__remark svg { flex-shrink: 0; margin-top: 1px; color: #ff8b7c; }
.kyc__remark b { color: #ff9b8c; display: block; margin-bottom: 1px; }

/* ── Section title ── */
.kyc__sec-title {
  display: flex; align-items: center; gap: 8px;
  font-size: 11.5px; font-weight: 700; letter-spacing: 0.05em; text-transform: uppercase;
  color: rgba(201,169,105,0.7); margin: 24px 4px 12px;
}
.kyc__sec-title:before { content: ''; width: 14px; height: 2px; border-radius: 2px; background: rgba(201,169,105,0.5); }

/* ── Form ── */
.kyc__field { margin-bottom: 14px; }
.kyc__label { display: block; font-size: 11px; font-weight: 600; letter-spacing: 0.03em; text-transform: uppercase; color: rgba(201,169,105,0.78); margin: 0 2px 8px; }
.kyc__input, .kyc__select {
  width: 100%; height: 52px; padding: 0 15px; border-radius: 14px;
  background: rgba(255,255,255,0.035); border: 1px solid rgba(201,169,105,0.18);
  color: #fff; font-size: 15px; font-weight: 600; outline: none;
  transition: border-color .18s ease, background .18s ease, box-shadow .18s ease;
}
.kyc__input::placeholder { color: rgba(255,255,255,0.26); font-weight: 500; }
.kyc__input:focus, .kyc__select:focus { border-color: rgba(201,169,105,0.55); background: rgba(255,255,255,0.06); box-shadow: 0 0 0 3px rgba(201,169,105,0.1); }
.kyc__select { appearance: none; -webkit-appearance: none; cursor: pointer; padding-right: 40px; }
.kyc__select option { background: #161513; color: #fff; }
.kyc__select-wrap { position: relative; }
.kyc__select-chev { position: absolute; right: 15px; top: 50%; transform: translateY(-50%); color: rgba(201,169,105,0.85); pointer-events: none; }

/* ── Document card ── */
.kyc__doc {
  position: relative; overflow: hidden;
  background: linear-gradient(155deg, rgba(255,255,255,0.04) 0%, rgba(255,255,255,0.01) 100%), #121110;
  border: 1px solid rgba(201,169,105,0.14); border-radius: 20px; padding: 17px;
  margin-bottom: 14px;
}
.kyc__doc-head { display: flex; align-items: center; gap: 10px; margin-bottom: 15px; }
.kyc__doc-ico { width: 38px; height: 38px; border-radius: 12px; flex-shrink: 0; display: flex; align-items: center; justify-content: center; background: rgba(201,169,105,0.1); border: 1px solid rgba(201,169,105,0.2); color: #e6cf95; }
.kyc__doc-title { font-size: 14.5px; font-weight: 700; color: #fff; flex: 1; }
.kyc__doc-opt { font-size: 9.5px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.04em; padding: 3px 9px; border-radius: 20px; background: rgba(255,255,255,0.06); color: rgba(255,255,255,0.5); }
.kyc__doc-req { font-size: 9.5px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.04em; padding: 3px 9px; border-radius: 20px; background: rgba(201,169,105,0.12); color: #e6cf95; }

/* ── Upload widget ── */
.kyc__uploads { display: flex; gap: 11px; }
.kyc__uploads .kyc__upload { flex: 1; min-width: 0; }
.kyc__upload-box {
  display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 7px;
  min-height: 104px; padding: 14px 8px; border-radius: 15px; cursor: pointer; text-align: center;
  background: rgba(255,255,255,0.025); border: 1.4px dashed rgba(201,169,105,0.4);
  color: rgba(201,169,105,0.85); transition: border-color .16s, background .16s, transform .12s;
  position: relative; overflow: hidden;
}
.kyc__upload-box:active { transform: scale(0.98); }
.kyc__upload-box.has-file { border-style: solid; border-color: rgba(74,222,128,0.45); background: rgba(74,222,128,0.04); }
.kyc__upload-side { font-size: 10px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.04em; color: rgba(255,255,255,0.42); }
.kyc__upload-txt { font-size: 11.5px; font-weight: 600; }
.kyc__upload-name { font-size: 10px; color: #4ade80; font-weight: 600; max-width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.kyc__upload-prev { position: absolute; inset: 0; object-fit: cover; width: 100%; height: 100%; }
.kyc__upload-prev-tag { position: absolute; bottom: 0; left: 0; right: 0; background: rgba(0,0,0,0.6); color: #4ade80; font-size: 9px; font-weight: 700; padding: 3px; text-align: center; }

.kyc__note {
  display: flex; gap: 9px; align-items: flex-start;
  font-size: 11.5px; color: rgba(255,255,255,0.48); line-height: 1.6; margin: 4px 4px 16px;
  padding: 11px 13px; border-radius: 13px; background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.06);
}
.kyc__note svg { flex-shrink: 0; margin-top: 1px; color: rgba(201,169,105,0.7); }
.kyc__note b { color: rgba(201,169,105,0.9); }

/* ── Submit ── */
.kyc__submit {
  width: 100%; height: 56px; margin-top: 8px; border: none; border-radius: 16px;
  display: flex; align-items: center; justify-content: center; gap: 9px; cursor: pointer;
  background: linear-gradient(135deg, #f7e0a0 0%, #C9A969 46%, #9c7733 100%);
  color: #1a1206; font-size: 15.5px; font-weight: 800; letter-spacing: 0.01em;
  box-shadow: 0 14px 30px -10px rgba(201,169,105,0.65), inset 0 1px 0 rgba(255,255,255,0.45);
  transition: transform .14s, opacity .2s;
}
.kyc__submit:active { transform: scale(0.98); }
.kyc__submit.disabled { opacity: 0.5; pointer-events: none; box-shadow: none; }
.kyc__secure { display: flex; align-items: center; justify-content: center; gap: 6px; margin: 14px 0 0; font-size: 10.5px; color: rgba(255,255,255,0.35); }
.kyc__secure svg { color: rgba(74,222,128,0.65); }

/* ── Submitted (read-only) view ── */
.kyc__sub-card { background: linear-gradient(155deg, rgba(255,255,255,0.04) 0%, rgba(255,255,255,0.01) 100%), #121110; border: 1px solid rgba(201,169,105,0.14); border-radius: 20px; padding: 17px; margin-bottom: 14px; }
.kyc__sub-row { display: flex; justify-content: space-between; gap: 12px; padding: 11px 0; border-bottom: 1px solid rgba(255,255,255,0.06); }
.kyc__sub-row:last-child { border-bottom: none; }
.kyc__sub-lbl { font-size: 12.5px; color: rgba(255,255,255,0.5); }
.kyc__sub-val { font-size: 13px; font-weight: 700; color: #fff; text-align: right; word-break: break-word; }
.kyc__sub-thumbs { display: flex; gap: 11px; margin-top: 14px; }
.kyc__sub-thumb { flex: 1; min-width: 0; border-radius: 14px; overflow: hidden; border: 1px solid rgba(201,169,105,0.18); background: rgba(0,0,0,0.3); }
.kyc__sub-thumb img { width: 100%; height: 96px; object-fit: cover; display: block; }
.kyc__sub-thumb a { display: block; }
.kyc__sub-thumb-lbl { font-size: 9.5px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.03em; color: rgba(255,255,255,0.45); text-align: center; padding: 5px; background: rgba(0,0,0,0.4); }
.kyc__sub-pdf { display: flex; align-items: center; justify-content: center; height: 96px; color: rgba(201,169,105,0.8); }
.kyc__resubmit {
  width: 100%; height: 52px; margin-top: 4px; border-radius: 15px; cursor: pointer; border: 1px solid rgba(255,107,92,0.3);
  display: flex; align-items: center; justify-content: center; gap: 8px;
  background: rgba(255,107,92,0.08); color: #ff8b7c;
  font-size: 14px; font-weight: 700; transition: background .15s;
}
.kyc__resubmit:active { background: rgba(255,107,92,0.16); }

.kyc__end-gap { height: 30px; }
`,
  styleScoped: false
};